import type { WebhookLog, WebhookDelivery } from '@/lib/types'

// Tradução de eventos técnicos para linguagem humana
export const EVENT_LABELS: Record<string, string> = {
  'coupon.created': 'Cupom criado',
  'referral.created': 'Indicação criada',
  'referral.rejected': 'Indicação rejeitada',
  'wallet.balance_available': 'Saldo liberado',
  'payout.requested': 'Saque solicitado',
  'order.paid': 'Pedido pago',
  'order.status.updated': 'Status do pedido atualizado',
  ping: 'Teste de conexão',
  mention: 'Menção',
  story_mention: 'Menção em story',
  changes: 'Alteração recebida',
  messaging: 'Mensagem recebida',
}

// Tradução de plataformas
export const PLATFORM_LABELS: Record<string, string> = {
  guru: 'Guru',
  yampi: 'Yampi',
  webhook: 'Notificação',
  klaviyo: 'Klaviyo',
  instagram: 'Instagram',
  api: 'API',
}

export type EventData = {
  id: string
  direction: 'inbound' | 'outbound'
  platform: string
  eventType?: string
  status: string
  createdAt: string
  payload?: Record<string, unknown>
  response?: Record<string, unknown> | string
  responseCode?: number
  url?: string | null
  errorMessage?: string
  attemptCount?: number
}

// Normaliza WebhookLog (entrada) para EventData
export function fromWebhookLog(log: WebhookLog): EventData {
  return {
    id: log.id,
    direction: 'inbound',
    platform: log.platform,
    eventType: log.eventType,
    status: log.status,
    createdAt: log.createdAt,
    payload: log.payload,
    response: log.response,
    errorMessage: log.errorMessage,
  }
}

// Normaliza WebhookDelivery (saída) para EventData
export function fromWebhookDelivery(delivery: WebhookDelivery): EventData {
  return {
    id: delivery.id,
    direction: 'outbound',
    platform: delivery.platform,
    eventType: delivery.eventType,
    status: delivery.status,
    createdAt: delivery.createdAt,
    payload: delivery.payload,
    response: delivery.responseBody,
    responseCode: delivery.responseCode,
    url: delivery.url,
    attemptCount: delivery.attemptCount,
  }
}
